<template>
  <div class="captcha-holder">
    <vue-recaptcha :sitekey="siteKey" @verify="$emit('validate', onVerify)"></vue-recaptcha>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  components: { VueRecaptcha },
  data() {
    return {
      recaptchaVerified: false
    }
  },
  props: {
    siteKey: {
      default: '',
      type: String
    }
  },
  methods: {
    onVerify: function (response) {
      if (response) this.recaptchaVerified = true;
      return this.recaptchaVerified;
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/admin/components/VRecaptcha.vue